import { APP_ENV } from "@config/config"

const isDevelopment = APP_ENV?.toLowerCase().includes("development")

export default isDevelopment
